import L from 'leaflet';
import { getDriverColor } from '../../utils/routeUtils';

// Fix for default marker icons in webpack environments
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

/**
 * Set up default Leaflet icon
 * This addresses the issue with missing marker icons in webpack environments
 */
export const setupDefaultIcon = () => {
  let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34]
  });

  L.Marker.prototype.options.icon = DefaultIcon;
  
  return DefaultIcon;
};

export const getIconColor = (point) => {
  if (point.isHome) {
    return '#000000';
  } else if (point.delivery_type === 'Farmtohome') {
    return '#ffcb21';
  } else if (point.delivery_type === 'PickUp') {
    return '#00aa00'; // toxic green
  } else if (point.driver_status !== 'Delivered'
    && point.driver_status !== 'Skipped'
    && point.driver_status !== 'Not Delivered'
  ) {
    return getDriverColor(point.driverNumber);
  }  else {
    return '#fff'
  }
}

export const getIconLabel = (point) => {
  if (point.isHome) {
    return 'H';
  } else if (point.driver_status === 'Delivered') {
    return 'V';
  } else if (point.driver_status === 'Not Delivered') {
    return 'X';
  } else if (point.driver_status === 'Skipped') {
    return 'S';
  } else {
    return point.displayOrder;
  } 
}

export const getIconBorderColor = (point) => {
  if (point.driver_status === 'Delivered'
    || point.driver_status === 'Skipped'
    || point.driver_status === 'Not Delivered'
    || point.delivery_type === 'Farmtohome'
    || point.delivery_type === 'PickUp'
  ) {
    return getDriverColor(point.driverNumber);
  } else {
    return '#fff';
  }
}

export const getIconLabelColor = (point) => {
  if (point.delivery_type === 'Farmtohome') {
    return '#000';
  } else if (point.delivery_type === 'PickUp') {
    return '#fff';
  } else {
    switch (point.driver_status) {
      case 'Delivered':
      return '#00b900';
    case 'Skipped':
      return '#65829e';
    case 'Not Delivered':
      return '#eb0001';
    default:
        return '#fff';  
    }
  }
}
/**
 * Creates a custom icon for a route stop
 * @param {Object} point - The route stop information
 * @param {Number} count - Optional. The number of shipments at this location 
 * @returns {L.DivIcon} A Leaflet divIcon with custom styling
 */
export const getRouteStopIcon = (point, count = 1) => {
  // Default color is black
  let color = getIconColor(point);
  let label = getIconLabel(point);  
  let labelColor = getIconLabelColor(point);
  let borderColor = getIconBorderColor(point);

  return L.divIcon({
    className: 'custom-div-icon',
    html: `
      <div style="
        background-color: ${color};
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid ${borderColor};
        box-shadow: 0 0 4px rgba(0,0,0,0.4);
        text-align: center;
        line-height: 28px;
        color: white;
        font-weight: bold;
        font-size: 14px;
        position: relative;
      ">
      <p style="color: ${labelColor}">
        ${label}
      </p>
        ${count > 1 ? `<span style="
          position: absolute;
          top: -5px;
          right: -5px;
          background-color: #222222;
          color: white;
          border: 1px solid white;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          font-size: 10px;
          line-height: 16px;
          text-align: center;
        ">${count}</span>` : ''}
      </div>
    `,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -15]
  });
}; 